import React, { useEffect, useMemo, useRef } from 'react';
import api from '../api';
import TTSOnay from '../pages/TTSOnay';
import TTSHakedis from '../pages/TTSHakedis';
import IhaleTakip from '../pages/IhaleTakip';
import IhaleDetay from '../pages/IhaleDetay';
import IhaleArac from '../pages/IhaleArac';
import Muhasebe from '../pages/Muhasebe';
import Kameralar from '../pages/Kameralar';
import AcilParcaSiparis from '../pages/AcilParcaSiparis';

const svgDataUrl = (title, toneA = '#1f7ae0', toneB = '#f39c12') =>
  `data:image/svg+xml;utf8,${encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 900">
      <defs>
        <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
          <stop stop-color="${toneA}" offset="0%"/>
          <stop stop-color="${toneB}" offset="100%"/>
        </linearGradient>
      </defs>
      <rect width="1200" height="900" fill="url(#g)"/>
      <rect x="70" y="70" width="1060" height="760" rx="42" fill="rgba(255,255,255,.16)" stroke="rgba(255,255,255,.4)" stroke-width="8"/>
      <text x="600" y="430" font-size="94" text-anchor="middle" font-family="Arial, sans-serif" font-weight="700" fill="white">${title}</text>
      <text x="600" y="520" font-size="34" text-anchor="middle" font-family="Arial, sans-serif" fill="rgba(255,255,255,.85)">OtoFlow Mobile Preview</text>
    </svg>
  `)}`;

const IHALE = {
  id: 101,
  ad: 'İSTAÇ Mobil Operasyon İhalesi',
  aciklama: 'Demo sonrası büyüyen TTS ve servis operasyonlarının mobil akışı',
  durum: 'aktif',
  toplam_bedel: 2850000,
  tamamlanan_tutar: 1864250,
  arac_sayisi: 18,
  baslangic_tar: '2026-04-01T08:00:00.000Z',
  bitis_tar: '2026-06-30T18:00:00.000Z',
};

const IHALE_ARACLAR = [
  {
    id: 1001,
    plaka: '34 OF 2026',
    marka: 'Ford',
    model: 'Transit',
    bolge: 'Hadımköy',
    talep_no: 'TLP-90214',
    servis_form_no: 'SF-1001',
    giris_tarihi: '2026-04-15T09:00:00.000Z',
    cikis_tarihi: '2026-04-18T15:30:00.000Z',
    durum: 'devam',
    sofor_ad: 'Murat Aydın',
    sofor_sicil: 'SF-4421',
    servis_notu: 'Ön takım kontrol edildi, kaporta ve far kalemleri sürüyor.',
    hakedis_durum: 'hazir',
    toplam_tutar: 84500,
  },
  {
    id: 1002,
    plaka: '34 OF 581',
    marka: 'Mercedes',
    model: 'Sprinter',
    bolge: 'İkitelli',
    talep_no: 'TLP-90187',
    servis_form_no: 'SF-1002',
    giris_tarihi: '2026-04-12T08:45:00.000Z',
    cikis_tarihi: '2026-04-16T12:20:00.000Z',
    durum: 'tamamlandi',
    sofor_ad: 'Ali Çetin',
    sofor_sicil: 'SF-2270',
    servis_notu: 'Araç teslime hazır.',
    hakedis_durum: 'tamamlandi',
    toplam_tutar: 61200,
  },
  {
    id: 1003,
    plaka: '34 OF 900',
    marka: 'Iveco',
    model: 'Daily',
    bolge: 'Avcılar',
    talep_no: 'TLP-90044',
    servis_form_no: 'SF-1003',
    giris_tarihi: '2026-04-11T11:15:00.000Z',
    cikis_tarihi: '',
    durum: 'devam',
    sofor_ad: 'Selçuk İnan',
    sofor_sicil: 'SF-8124',
    servis_notu: '',
    hakedis_durum: 'bekliyor',
    toplam_tutar: 39850,
  },
];

const KALEMLER = {
  1001: [
    { id: 1, sozlesme_no: 'K-144', parca_kodu: 'FR-02', malzeme_kodu: 'MLZ-02', aciklama: 'Ön tampon komple', marka: 'OEM', hizmet_turu: 'P', olcu_birimi: 'ADET', miktar: 1, net_fiyat: 18500, tutar: 18500 },
    { id: 2, sozlesme_no: 'K-311', parca_kodu: 'FR-18', malzeme_kodu: 'MLZ-18', aciklama: 'Sol far grubu', marka: 'Valeo', hizmet_turu: 'P', olcu_birimi: 'ADET', miktar: 1, net_fiyat: 9200, tutar: 9200 },
    { id: 3, sozlesme_no: 'K-800', parca_kodu: 'ISC-04', malzeme_kodu: 'ISC-04', aciklama: 'Kaporta işçiliği', marka: 'Servis', hizmet_turu: 'I', olcu_birimi: 'SAAT', miktar: 6, net_fiyat: 1250, tutar: 7500 },
  ],
  1002: [
    { id: 4, sozlesme_no: 'K-501', parca_kodu: 'YN-11', malzeme_kodu: 'YN-11', aciklama: 'Yan kapı rayı', marka: 'OEM', hizmet_turu: 'P', olcu_birimi: 'ADET', miktar: 1, net_fiyat: 11800, tutar: 11800 },
    { id: 5, sozlesme_no: 'K-912', parca_kodu: 'BOY-07', malzeme_kodu: 'BOY-07', aciklama: 'Boya hazırlık ve uygulama', marka: 'Servis', hizmet_turu: 'I', olcu_birimi: 'SAAT', miktar: 4, net_fiyat: 1450, tutar: 5800 },
  ],
  1003: [
    { id: 6, sozlesme_no: 'K-050', parca_kodu: 'GRL-09', malzeme_kodu: 'GRL-09', aciklama: 'Ön panjur', marka: 'OEM', hizmet_turu: 'P', olcu_birimi: 'ADET', miktar: 1, net_fiyat: 6400, tutar: 6400 },
  ],
};

const FOTOGRAFLAR = {
  1001: [
    { id: 31, tip: 'sokullen', dosya_data: svgDataUrl('Sökülen', '#243b55', '#141e30'), created_at: '2026-04-15T10:10:00.000Z' },
    { id: 32, tip: 'takilan', dosya_data: svgDataUrl('Takılan', '#0f9b0f', '#56ab2f'), created_at: '2026-04-16T14:10:00.000Z' },
    { id: 33, tip: 'genel', dosya_data: svgDataUrl('Genel', '#4b79a1', '#283e51'), created_at: '2026-04-16T16:40:00.000Z' },
  ],
  1002: [
    { id: 34, tip: 'genel', dosya_data: svgDataUrl('Teslim', '#f7971e', '#ffd200'), created_at: '2026-04-16T11:20:00.000Z' },
  ],
  1003: [
    { id: 35, tip: 'sokullen', dosya_data: svgDataUrl('Hasar', '#c0392b', '#8e44ad'), created_at: '2026-04-12T12:40:00.000Z' },
  ],
};

const OLAY_ONAY = {
  1001: { onaylayan: 'Doruk Kantar', tarih: '2026-04-17T14:35:00.000Z', tur: 'web', not_alani: 'Mobil onay akışı kontrol edildi.' },
  1002: { onaylayan: 'Doruk Kantar', tarih: '2026-04-15T11:20:00.000Z', tur: 'mail', not_alani: 'Teslim öncesi onay tamamlandı.' },
  1003: null,
};

const MUHASEBE_ARACLAR = [
  {
    id: 2001,
    plaka: '34 OF 2026',
    marka: 'Ford',
    model: 'Transit',
    lokasyon: 'hadimkoy',
    hasar_turu: 'kasko',
    firma_adi: 'İSTAÇ A.Ş.',
    sasi_no: 'WF0AXXTTGXSR10001',
    fatura_durum: 'bekliyor',
    fatura_no: '',
    ekspetriz_ozet: JSON.stringify({ toplam_kalem: 6, iscilik_toplam: 15400 }),
  },
  {
    id: 2002,
    plaka: '34 OF 581',
    marka: 'Mercedes',
    model: 'Sprinter',
    lokasyon: 'ikitelli',
    hasar_turu: 'trafik',
    firma_adi: 'İETT',
    sasi_no: 'WDB9076351P110002',
    fatura_durum: 'kesildi',
    fatura_no: 'FTR-2026-118',
    ekspetriz_ozet: JSON.stringify({ toplam_kalem: 4, iscilik_toplam: 9200 }),
  },
  {
    id: 2003,
    plaka: '34 OF 900',
    marka: 'Iveco',
    model: 'Daily',
    lokasyon: 'hadimkoy',
    hasar_turu: 'nakit',
    firma_adi: 'İSFALT',
    sasi_no: 'ZCFC35A9000003333',
    fatura_durum: 'iptal',
    fatura_no: 'FTR-2026-044',
    ekspetriz_ozet: JSON.stringify({ toplam_kalem: 2, iscilik_toplam: 3400 }),
  },
];

const KAMERA_AYAR = {
  deger: {
    lokasyonlar: {
      ikitelli: {
        ad: 'İkitelli',
        ic: [
          { id: 1, ad: 'Kapı Giriş', uuid: 'ikitelli-1' },
          { id: 2, ad: 'Atölye Orta Alan', uuid: 'ikitelli-2' },
        ],
        dis: [
          { id: 3, ad: 'Araç Parkı', uuid: 'ikitelli-3' },
          { id: 4, ad: 'Güvenlik Noktası', uuid: '' },
        ],
      },
      hadimkoy: {
        ad: 'Hadımköy',
        ic: [
          { id: 1, ad: 'Mekanik Hat', uuid: 'hadimkoy-1' },
          { id: 2, ad: 'Yedek Parça Rafı', uuid: 'hadimkoy-2' },
        ],
        dis: [
          { id: 3, ad: 'Servis Girişi', uuid: 'hadimkoy-3' },
          { id: 4, ad: 'Teslim Alanı', uuid: 'hadimkoy-4' },
        ],
      },
    },
  },
};

const PREVIEW_USER = {
  id: 1,
  ad_soyad: 'Doruk Kantar',
  kullanici_adi: 'doruk',
  kul_adi: 'doruk',
  rol: 'yonetici',
  lokasyon: 'ikitelli',
};

const parseUrl = (rawUrl = '') => rawUrl.split('?')[0];

const responseForGet = (rawUrl) => {
  const url = parseUrl(rawUrl);
  if (url === '/ihale') return [IHALE];
  if (url === `/ihale/${IHALE.id}`) return IHALE;
  if (url === `/ihale/${IHALE.id}/araclar`) return IHALE_ARACLAR;
  if (url.startsWith('/ihale/bolgeler')) return ['Hadımköy', 'İkitelli', 'Avcılar', 'Pendik'];
  if (url === '/araclar/muhasebe') return MUHASEBE_ARACLAR;
  if (url === '/ayarlar/kameralar') return KAMERA_AYAR;

  const kalemMatch = url.match(/^\/ihale\/araclar\/(\d+)\/kalemler$/);
  if (kalemMatch) return KALEMLER[Number(kalemMatch[1])] || [];

  const fotoMatch = url.match(/^\/ihale\/araclar\/(\d+)\/fotograflar$/);
  if (fotoMatch) return FOTOGRAFLAR[Number(fotoMatch[1])] || [];

  const onayMatch = url.match(/^\/ihale\/araclar\/(\d+)\/onay$/);
  if (onayMatch) return OLAY_ONAY[Number(onayMatch[1])] || null;

  return [];
};

function PreviewFrame({ children }) {
  return <>{children}</>;
}

export default function MobilePreviewRoute() {
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const screen = params.get('screen') || 'ihale-takip';
  const originalApiRef = useRef(null);
  const previewAppliedRef = useRef(false);

  if (!previewAppliedRef.current) {
    previewAppliedRef.current = true;
    originalApiRef.current = {
      get: api.get.bind(api),
      post: api.post.bind(api),
      put: api.put.bind(api),
      delete: api.delete.bind(api),
    };

    window.alert = () => {};
    window.confirm = () => true;
    localStorage.removeItem('otoflow_token');

    api.get = async (url) => ({ data: responseForGet(url) });
    api.post = async (url, body) => {
      if (url.includes('/onay')) {
        return {
          data: {
            onaylayan: PREVIEW_USER.ad_soyad,
            tarih: new Date().toISOString(),
            ...(body || {}),
          },
        };
      }
      return { data: { ok: true, mesaj: 'preview' } };
    };
    api.put = async () => ({ data: { ok: true } });
    api.delete = async () => ({ data: { ok: true } });
    document.body.style.background = 'var(--bg)';
  }

  useEffect(() => {
    return () => {
      if (!originalApiRef.current) return;
      api.get = originalApiRef.current.get;
      api.post = originalApiRef.current.post;
      api.put = originalApiRef.current.put;
      api.delete = originalApiRef.current.delete;
    };
  }, []);

  useEffect(() => {
    const pickClickable = (text, selector = 'button,div') =>
      Array.from(document.querySelectorAll(selector)).find((node) => {
        const content = (node.textContent || '').trim();
        if (!content.includes(text)) return false;
        const style = window.getComputedStyle(node);
        return style.cursor === 'pointer' || node.tagName === 'BUTTON';
      });

    const queue = [];

    if (screen === 'tts-onay') {
      queue.push(() => pickClickable('İSTAÇ Mobil Operasyon İhalesi')?.click());
      queue.push(() => pickClickable('34 OF 2026')?.click());
    }

    if (screen === 'tts-hakedis') {
      queue.push(() => pickClickable('İSTAÇ Mobil Operasyon İhalesi')?.click());
    }

    if (screen === 'ihale-arac') {
      queue.push(() => pickClickable('Fotoğraflar')?.click());
    }

    if (screen === 'kameralar') {
      queue.push(() => pickClickable('İkitelli')?.click());
    }

    const timers = queue.map((step, index) =>
      window.setTimeout(() => {
        try {
          step();
        } catch {}
      }, 900 + index * 900)
    );

    return () => timers.forEach((timer) => window.clearTimeout(timer));
  }, [screen]);

  const commonProps = {
    kullanici: PREVIEW_USER,
    canGor: () => true,
    canDuzenle: () => true,
  };

  if (screen === 'tts-onay') {
    return (
      <PreviewFrame>
        <TTSOnay kullanici={{ ...PREVIEW_USER, rol: 'onay_mercii' }} cikisYap={() => {}} />
      </PreviewFrame>
    );
  }

  if (screen === 'tts-hakedis') {
    return (
      <PreviewFrame>
        <TTSHakedis kullanici={{ ...PREVIEW_USER, rol: 'hakedis' }} cikisYap={() => {}} />
      </PreviewFrame>
    );
  }

  if (screen === 'ihale-detay') {
    return (
      <PreviewFrame>
        <IhaleDetay
          {...commonProps}
          ihale={IHALE}
          onGeri={() => {}}
          onAracDetay={() => {}}
        />
      </PreviewFrame>
    );
  }

  if (screen === 'ihale-arac') {
    return (
      <PreviewFrame>
        <IhaleArac
          {...commonProps}
          ihale={IHALE}
          arac={IHALE_ARACLAR[0]}
          onGeri={() => {}}
        />
      </PreviewFrame>
    );
  }

  if (screen === 'muhasebe') {
    return (
      <PreviewFrame>
        <Muhasebe
          {...commonProps}
          onGeriDon={() => {}}
          onAracAc={() => {}}
        />
      </PreviewFrame>
    );
  }

  if (screen === 'kameralar') {
    return (
      <PreviewFrame>
        <Kameralar
          kullanici={PREVIEW_USER}
          onGeriDon={() => {}}
        />
      </PreviewFrame>
    );
  }

  if (screen === 'acil-parca') {
    return (
      <PreviewFrame>
        <AcilParcaSiparis
          {...commonProps}
          onGeri={() => {}}
        />
      </PreviewFrame>
    );
  }

  if (screen === 'ihale-takip') {
    return (
      <PreviewFrame>
        <IhaleTakip
          {...commonProps}
          onGeri={() => {}}
          onIhaleDetay={() => {}}
        />
      </PreviewFrame>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', fontFamily: "'Barlow',sans-serif", color: 'var(--ink)' }}>
      Önizleme ekranı bulunamadı.
    </div>
  );
}
